// hooks/useCustomerHistory.js
import { useCallback, useState } from "react";

import CustomerAPI from "../../../CustomerAPI";

const customerAPI = new CustomerAPI();

export default function useCustomerHistory(customerId) {
  const [isLoading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);

  const getHistory = useCallback(async () => {
    if (!customerId) return;
    try {
      setLoading(true);
      const response = await customerAPI.getHistory(customerId);
      setHistory(Array.isArray(response.data) ? response.data : []);
    } catch {
      setHistory([]);
    } finally {
      setLoading(false);
    }
  }, [customerId]);

  return { isLoading, history, getHistory };
}
